// extracted by mini-css-extract-plugin
module.exports = {"root":"Products_root__MiGTU","searchAll":"Products_searchAll__obFVx","link":"Products_link__9_iYZ"};